import { observer } from "mobx-react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { portalStore } from "../../../../Stores/portal";
import { TextField } from "@mui/material";
import { authStore } from "../../../../App";

interface NewStoreProps {}

const _NewStore: React.FC<NewStoreProps> = () => {
  return (
    <Container
      style={{
        alignContent: "center",
        background: "transparent",
        height: portalStore.portalHeight,
      }}
    >
      <Row>
        <Col md={8} style={{ background: "transparent" }}>
          <h1 style={{ fontSize: "100px", textAlign: "center" }}>🎮</h1>
        </Col>
        <Col
          md={4}
          style={{
            background: "transparent",
            textAlign: "center",
            display: "flex",
            flexFlow: "row",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexFlow: "column",
              alignItems: "center",
              background: "transparent",
              width: "100%",
              gap: "30px",
            }}
          >
            <TextField
              id="filled-basic"
              label="Store name"
              variant="filled"
              style={{ textAlign: "center" }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                authStore.addStore({
                  companyId: "",
                  storeId: "",
                  storeName: "Silly",
                  id: "",
                });
              }}
            >
              Create
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const NewStore = observer(_NewStore);
export { NewStore };
